<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__block-outer">
      <div class="form-section-base__block-inner">
        <div class="form-section-base__title">
          Сведения о доверенности в машиночитаемом виде
        </div>
        <MrpaUploader
          :v="$v"
          @parsed-mrpa-change="parsedMrpaChangeHandler"
          :statement-id="statementId"
          :statement-type="StatementType.NOTICE_RECOVERY"
        />
      </div>
    </div>

    <div class="form-base pt-0" v-if="formVisible">
      <MachinePerson
        v-if="role === Role.PERSON"
        :v="$v.applicant.person"
        :is-alternative-service-edit="isAlternativeServiceEdit"
      >
        <template>
          <div class="form-base__title">Сведения о взыскателе (заявителе)</div>

          <div class="form-section-base__controls">
            <v-row>
              <v-col>
                <v-radio-group v-model="role" row>
                  <v-radio label="Физическое лицо" :value="Role.PERSON"/>
                  <v-radio
                    label="Юридическое лицо"
                    :value="Role.ORGANIZATION"
                  />
                  <v-radio
                    label="Иностранное юридическое лицо"
                    :value="Role.FOREIGN_ORGANIZATION"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </div>
        </template>
      </MachinePerson>

      <MachineOrganization
        v-if="role === Role.ORGANIZATION"
        :v="$v.applicant.organization"
        :is-alternative-service-edit="isAlternativeServiceEdit"
      >
        <template>
          <div class="form-base__title">Сведения о взыскателе (заявителе)</div>

          <div class="form-section-base__controls">
            <v-row>
              <v-col>
                <v-radio-group v-model="role" row>
                  <v-radio label="Физическое лицо" :value="Role.PERSON"/>
                  <v-radio
                    label="Юридическое лицо"
                    :value="Role.ORGANIZATION"
                  />
                  <v-radio
                    label="Иностранное юридическое лицо"
                    :value="Role.FOREIGN_ORGANIZATION"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </div>
        </template>
      </MachineOrganization>

      <MachineForeignOrganization
        v-if="role === Role.FOREIGN_ORGANIZATION"
        :v="$v.applicant.foreignOrganization"
        :is-alternative-service-edit="isAlternativeServiceEdit"
      >
        <template>
          <div class="form-base__title">Сведения о взыскателе (заявителе)</div>

          <div class="form-section-base__controls">
            <v-row>
              <v-col>
                <v-radio-group v-model="role" row>
                  <v-radio label="Физическое лицо" :value="Role.PERSON"/>
                  <v-radio
                    label="Юридическое лицо"
                    :value="Role.ORGANIZATION"
                  />
                  <v-radio
                    label="Иностранное юридическое лицо"
                    :value="Role.FOREIGN_ORGANIZATION"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </div>
        </template>
      </MachineForeignOrganization>
    </div>
    <v-container>
      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import {mdiAlertCircleOutline} from '@mdi/js';
import {Role} from '@/utils/dictionaries';
import {leaveStep, checkInvalid} from '@/utils/services';
import Footer from '@/components/services/elements/Footer';
import {StepDirection, StepName} from '@/types/services';
import {getValidationErrorText} from '@/utils/validate';
import cloneDeep from 'clone-deep';
import {ServicesModule} from '@/store/modules/services';
import deepmerge from 'deepmerge';
import MrpaUploader, {
  getMrpa,
  mrpaUploaderModel,
  mrpaUploaderValidation,
  prefillMrpDisabled,
} from '@/components/services/elements/MrpaUploader';
import MachinePerson, {
  machinePersonModel,
  getMachinePersonValidation,
} from './MachinePerson';
import MachineOrganization, {
  machineOrganizationModel,
  getMachineOrganizationValidation,
} from './MachineOrganization';
import MachineForeignOrganization, {
  machineForeignOrganizationModel,
  getMachineForeignOrganizationValidation,
} from './MachineForeignOrganization';
import {MrpaSubjectModule} from '@/store/modules/mrpaSubject';
import {MrpaType, StatementType} from '@/constants';
import {getDefaultMachineTrustee} from '@/components/services/elements/MrpaTrustee';
import {assemblyMrpaModel} from '@/components/services/common/MrpaSubjectForm';

const getDefaultForm = () => ({
  person: cloneDeep(machinePersonModel),
  organization: cloneDeep(machineOrganizationModel),
  foreignOrganization: cloneDeep(machineForeignOrganizationModel),
});

export default {
  name: 'Machine',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
    isAlternativeServiceEdit: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    MachinePerson,
    MachineOrganization,
    MachineForeignOrganization,
    Footer,
    MrpaUploader,
  },
  data() {
    return {
      StatementType,
      mdiAlertCircleOutline,
      getValidationErrorText,
      mrpa: cloneDeep(mrpaUploaderModel.mrpa),
      formVisible: mrpaUploaderModel.formVisible,
      applicant: getDefaultForm(),
      StepDirection,
      StepName,
      leaveStep,
      Role,
      invalidFields: [],
      role: Role.FOREIGN_ORGANIZATION,
      trusteeRole: Role.PERSON,
      statementId: null,
    };
  },
  validations() {
    return {
      ...mrpaUploaderValidation,
      applicant: {
        person: getMachinePersonValidation(this.applicant.person),
        organization: getMachineOrganizationValidation(
          this.applicant.organization
        ),
        foreignOrganization: getMachineForeignOrganizationValidation(
          this.applicant.foreignOrganization
        ),
      },
    };
  },
  created() {
    this.statementId = ServicesModule.statement.id;
    const applicantStore = cloneDeep(
      ServicesModule.statement.subjects.applicant
    );

    if (applicantStore?.trustee) {
      this.prefillDraft(applicantStore, false);
    }
  },
  methods: {
    prefillDraft(applicant, isMrpa) {
      if (isMrpa) {
        prefillMrpDisabled(applicant);
      }

      if (applicant.person) {
        this.role = Role.PERSON;

        const person = {
          ...applicant.person,
          isBusinessman:
            applicant.person.isBusinessman || Boolean(applicant.person.ogrn),
        };

        this.applicant.person = deepmerge.all([
          machinePersonModel,
          person,
          {
            trustee: getDefaultMachineTrustee(applicant.trustee),
          },
        ]);
      }

      if (applicant.organization) {
        this.role = Role.ORGANIZATION;
        this.applicant.organization = deepmerge.all([
          machineOrganizationModel,
          applicant.organization,
          {
            trustee: getDefaultMachineTrustee(applicant.trustee),
          },
        ]);
      }

      if (applicant.foreignOrganization) {
        this.role = Role.FOREIGN_ORGANIZATION;
        this.applicant.foreignOrganization = deepmerge.all([
          machineForeignOrganizationModel,
          applicant.foreignOrganization,
          {
            trustee: getDefaultMachineTrustee(applicant.trustee),
          },
        ]);
      }

      this.mrpa = getMrpa(applicant);
      this.formVisible = true;
      this.touchFields()
    },

    assemblyModel() {
      return assemblyMrpaModel({
        subject: this.applicant,
        role: this.role,
        mrpa: this.mrpa,
      });
    },

    async touchFields() {
      this.invalidFields = [];

      this.$v.formVisible.$touch();

      if (this.$v.formVisible.$invalid) {
        checkInvalid(this.$v.formVisible, this.invalidFields);
        return;
      }

      this.$v.applicant[this.role].$touch();

      checkInvalid(this.$v.applicant[this.role], this.invalidFields);

      if (this.invalidFields.length === 0) {
        if (this.mrpa.type === MrpaType.BY_GUID) {
          const isMrpaValid = await this.checkMrpaGuid();

          if (!isMrpaValid) this.invalidFields.push(true);
        }
      }
    },

    parsedMrpaChangeHandler(parsedMrpa) {
      if (parsedMrpa) {
        this.prefillDraft(parsedMrpa, true);
        this.formVisible = true;
      } else {
        this.role = Role.PERSON;
        this.applicant = getDefaultForm();
        this.formVisible = null;
      }
    },

    async checkMrpaGuid() {
      try {
        await MrpaSubjectModule.checkMrpaSubjectGuid({
          statementId: this.statementId,
          guid: this.mrpa.guid,
          issuerInn: this.mrpa.issuerInn,
        });

        return true;
      } catch (e) {
        return false;
      }
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StepName.S2,
      });
    },
  },
};
</script>
